import * as THREE from 'three'

import Loader from './Utils/Loader.js'
import EventEmitter from './Utils/EventEmitter.js'

// Matcaps贴图
import matcapBeigeSource from '../models/matcaps/beige.png'
import matcapBlackSource from '../models/matcaps/black.png'
import matcapOrangeSource from '../models/matcaps/orange.png'
import matcapRedSource from '../models/matcaps/red.png'
import matcapWhiteSource from '../models/matcaps/white.png'
import matcapGreenSource from '../models/matcaps/green.png'
import matcapBrownSource from '../models/matcaps/brown.png'
import matcapGraySource from '../models/matcaps/gray.png'
import matcapEmeraldGreenSource from '../models/matcaps/emeraldGreen.png'
import matcapPurpleSource from '../models/matcaps/purple.png'
import matcapBlueSource from '../models/matcaps/blue.png'
import matcapLightBlueSource from '../models/matcaps/lightBlue.png'
import matcapYellowSource from '../models/matcaps/yellow.png'
import matcapMetalSource from '../models/matcaps/metal.png'
import matcapGoldSource from '../models/matcaps/gold.png'

// 字母
import introStaticBaseSource from '../models/intro/static/base.glb'
import introStaticCollisionSource from '../models/intro/static/collision.glb'
import introStaticFloorShadowSource from '../models/intro/static/floorShadow.png'

import introInstructionsLabelsSource from '../models/intro/instructions/labels.glb'
import introInstructionsArrowsSource from '../models/intro/instructions/arrows.png'
import introInstructionsControlsSource from '../models/intro/instructions/controls.png'
import introInstructionsOtherSource from '../models/intro/instructions/other.png'

import introArrowKeyBaseSource from '../models/intro/arrowKey/base.glb'
import introArrowKeyCollisionSource from '../models/intro/arrowKey/collision.glb'

import introZBaseSource from '../models/intro/z/base.glb'
import introZCollisionSource from '../models/intro/z/collision.glb'

import introHBaseSource from '../models/intro/h/base.glb'
import introHCollisionSource from '../models/intro/h/collision.glb'

import introABaseSource from '../models/intro/a/base.glb'
import introACollisionSource from '../models/intro/a/collision.glb'

// import introQBaseSource from '../models/intro/q/base.glb'
// import introQCollisionSource from '../models/intro/q/collision.glb'

import introBBaseSource from '../models/intro/b/base.glb'
import introBCollisionSource from '../models/intro/b/collision.glb'

import introRBaseSource from '../models/intro/r/base.glb'
import introRCollisionSource from '../models/intro/r/collision.glb'

import introUBaseSource from '../models/intro/u/base.glb'
import introUCollisionSource from '../models/intro/u/collision.glb'

import introNBaseSource from '../models/intro/n/base.glb'
import introNCollisionSource from '../models/intro/n/collision.glb'

import introOBaseSource from '../models/intro/o/base.glb'
import introOCollisionSource from '../models/intro/o/collision.glb'

import introSBaseSource from '../models/intro/s/base.glb'
import introSCollisionSource from '../models/intro/s/collision.glb'

import introGBaseSource from '../models/intro/g/base.glb'
import introGCollisionSource from '../models/intro/g/collision.glb'

import introQBaseSource from '../models/intro/q/base.glb'
import introQCollisionSource from '../models/intro/q/collision.glb'

import introIBaseSource from '../models/intro/i/base.glb'
import introICollisionSource from '../models/intro/i/collision.glb'

import introMBaseSource from '../models/intro/m/base.glb'
import introMCollisionSource from '../models/intro/m/collision.glb'

import introHoppinBaseSource from '../models/intro/hoppin/base.glb'
import introHoppinCollisionSource from '../models/intro/hoppin/collision.glb'

import introZqBaseSource from '../models/intro/zq/base.glb'
import introZqCollisionSource from '../models/intro/zq/collision.glb'

import crossroadsStaticFloorShadowSource from '../models/crossroads/static/floorShadow.png'
import crossroadsStaticBaseSource from '../models/crossroads/static/base.glb'
import crossroadsStaticCollisionSource from '../models/crossroads/static/collision.glb'

// 汽车模型
import carDefaultChassisSource from '../models/car/default/chassis.glb'
import carDefaultWheelSource from '../models/car/default/wheel.glb'
import carDefaultBackLightsBrakeSource from '../models/car/default/backLightsBrake.glb'
import carDefaultBackLightsReverseSource from '../models/car/default/backLightsReverse.glb'
import carDefaultAntenaSource from '../models/car/default/antena.glb'

import carCyberTruckChassisSource from '../models/car/cyberTruck/chassis.glb'
import carCyberTruckWheelSource from '../models/car/cyberTruck/wheel.glb'
import carCyberTruckBackLightsBrakeSource from '../models/car/cyberTruck/backLightsBrake.glb'
import carCyberTruckBackLightsReverseSource from '../models/car/cyberTruck/backLightsReverse.glb'
import carCyberTruckAntenaSource from '../models/car/cyberTruck/antena.glb'

// 项目
import projectsBoardStructureSource from '../models/projects/board/structure.glb'
import projectsBoardCollisionSource from '../models/projects/board/collision.glb'
import projectsBoardStructureFloorShadowSource from '../models/projects/board/floorShadow.png'
import projectsBoardPlaneSource from '../models/projects/board/plane.glb'

import projectsBoardStructureHSource from '../models/projects/board/structureH.glb'
import projectsBoardPlaneHSource from '../models/projects/board/planeH.glb'

import projectsDistinctionsCollisionLBaseSource from '../models/projects/distinctions/collisionL.glb'
import projectsDistinctionsCollisionSBaseSource from '../models/projects/distinctions/collisionS.glb'

import projectsDistinctionsActivitiBaseSource from '../models/projects/distinctions/Activiti/base.glb'
import projectsDistinctionsCBaseSource from '../models/projects/distinctions/C/base.glb'
import projectsDistinctionsChatGPTBaseSource from '../models/projects/distinctions/ChatGPT/base.glb'
import projectsDistinctionsDubboBaseSource from '../models/projects/distinctions/Dubbo/base.glb'
import projectsDistinctionsDockerBaseSource from '../models/projects/distinctions/Docker/base.glb'
import projectsDistinctionsElasticsearchBaseSource from '../models/projects/distinctions/Elasticsearch/base.glb'
import projectsDistinctionsEurekaBaseSource from '../models/projects/distinctions/Eureka/base.glb'
import projectsDistinctionsFeignBaseSource from '../models/projects/distinctions/Feign/base.glb'
import projectsDistinctionsGolangBaseSource from '../models/projects/distinctions/Golang/base.glb'
import projectsDistinctionsHadoopBaseSource from '../models/projects/distinctions/Hadoop/base.glb'
import projectsDistinctionsHystrixBaseSource from '../models/projects/distinctions/Hystrix/base.glb'
import projectsDistinctionsJavaBaseSource from '../models/projects/distinctions/Java/base.glb'
import projectsDistinctionsJMeterBaseSource from '../models/projects/distinctions/JMeter/base.glb'
import projectsDistinctionsJQueryBaseSource from '../models/projects/distinctions/JQuery/base.glb'
import projectsDistinctionsKafkaBaseSource from '../models/projects/distinctions/Kafka/base.glb'
import projectsDistinctionsLuceneBaseSource from '../models/projects/distinctions/Lucene/base.glb'
import projectsDistinctionsMongoDBBaseSource from '../models/projects/distinctions/MongoDB/base.glb'
import projectsDistinctionsMybatisBaseSource from '../models/projects/distinctions/Mybatis/base.glb'
import projectsDistinctionsMysqlBaseSource from '../models/projects/distinctions/Mysql/base.glb'
import projectsDistinctionsNacosBaseSource from '../models/projects/distinctions/Nacos/base.glb'
import projectsDistinctionsNodeBaseSource from '../models/projects/distinctions/Node/base.glb'
import projectsDistinctionsOracleBaseSource from '../models/projects/distinctions/Oracle/base.glb'
import projectsDistinctionsPythonBaseSource from '../models/projects/distinctions/Python/base.glb'
import projectsDistinctionsQuartzBaseSource from '../models/projects/distinctions/Quartz/base.glb'
import projectsDistinctionsReactBaseSource from '../models/projects/distinctions/React/base.glb'
import projectsDistinctionsRedisBaseSource from '../models/projects/distinctions/Redis/base.glb'
import projectsDistinctionsRibbonBaseSource from '../models/projects/distinctions/Ribbon/base.glb'
import projectsDistinctionsRocketMQBaseSource from '../models/projects/distinctions/RocketMQ/base.glb'
import projectsDistinctionsSpringBaseSource from '../models/projects/distinctions/Spring/base.glb'
import projectsDistinctionsThreeBaseSource from '../models/projects/distinctions/Three/base.glb'
import projectsDistinctionsVUEBaseSource from '../models/projects/distinctions/VUE/base.glb'
import projectsDistinctionsZookeeperBaseSource from '../models/projects/distinctions/Zookeeper/base.glb'

import projectsHoppinBlogFloorSource from '../models/projects/hoppinBlog/floorTexture.png'
import projectsZQProfileFloorSource from '../models/projects/zqProfile/floorTexture.png'
import projectsHoppinVideoFloorSource from '../models/projects/hoppinVideo/floorTexture.png'
import projectsHoppinChatFloorSource from '../models/projects/hoppinChat/floorTexture.png'
import projectsHoppinZuiFloorSource from '../models/projects/hoppinZui/floorTexture.png'
import projectsHoppinManagerFloorSource from '../models/projects/hoppinManager/floorTexture.png'
import projectsValorantFloorSource from '../models/projects/valorant/floorTexture.png'
import projectsHoppinOtherFloorSource from '../models/projects/hoppinOther/floorTexture.png'
import projectsYqcrFloorSource from '../models/projects/yqcr/floorTexture.png'

//

import informationStaticBaseSource from '../models/information/static/base.glb'
import informationStaticCollisionSource from '../models/information/static/collision.glb'
import informationStaticFloorShadowSource from '../models/information/static/floorShadow.png'

import informationBaguetteBaseSource from '../models/information/baguette/base.glb'
import informationBaguetteCollisionSource from '../models/information/baguette/collision.glb'

import informationContactQQLabelSource from '../models/information/static/contactQQLabel.png'
import informationContactGithubLabelSource from '../models/information/static/contactGithubLabel.png'
import informationContactWXLabelSource from '../models/information/static/contactWXLabel.png'
import informationContactMailLabelSource from '../models/information/static/contactMailLabel.png'

import informationActivitiesSource from '../models/information/static/activities.png'

import playgroundStaticFloorShadowSource from '../models/playground/static/floorShadow.png'
import playgroundStaticBaseSource from '../models/playground/static/base.glb'
import playgroundStaticCollisionSource from '../models/playground/static/collision.glb'

import brickBaseSource from '../models/brick/base.glb'
import brickCollisionSource from '../models/brick/collision.glb'

import hornBaseSource from '../models/horn/base.glb'
import hornCollisionSource from '../models/horn/collision.glb'

import lemonBaseSource from '../models/lemon/base.glb'
import lemonCollisionSource from '../models/lemon/collision.glb'

import bowlingBallBaseSource from '../models/bowlingBall/base.glb'
import bowlingBallCollisionSource from '../models/bowlingBall/collision.glb'

import bowlingPinBaseSource from '../models/bowlingPin/base.glb'
import bowlingPinCollisionSource from '../models/bowlingPin/collision.glb'

import areaKeyEnterSource from '../models/area/keyEnter.png'
import areaEnterSource from '../models/area/enter.png'
import areaOpenSource from '../models/area/open.png'
import areaResetSource from '../models/area/reset.png'
import areaQuestionMarkSource from '../models/area/questionMark.png'

import tilesABaseSource from '../models/tiles/a/base.glb'
import tilesACollisionSource from '../models/tiles/a/collision.glb'

import tilesBBaseSource from '../models/tiles/b/base.glb'
import tilesBCollisionSource from '../models/tiles/b/collision.glb'

import tilesCBaseSource from '../models/tiles/c/base.glb'
import tilesCCollisionSource from '../models/tiles/c/collision.glb'

import tilesDBaseSource from '../models/tiles/d/base.glb'
import tilesDCollisionSource from '../models/tiles/d/collision.glb'

import tilesEBaseSource from '../models/tiles/e/base.glb'
import tilesECollisionSource from '../models/tiles/e/collision.glb'
import konamiLabelSource from '../models/konami/label.png'
import konamiLabelTouchSource from '../models/konami/label-touch.png'
import wig1Source from '../models/wigs/wig1.glb'
import wig2Source from '../models/wigs/wig2.glb'
import wig3Source from '../models/wigs/wig3.glb'
import wig4Source from '../models/wigs/wig4.glb'
import eggBaseSource from '../models/egg/base.glb'
import eggCollisionSource from '../models/egg/collision.glb'

export default class Resources extends EventEmitter
{
    constructor()
    {
        super()

        this.loader = new Loader()
        this.items = {}

        this.loader.load([
            // Matcaps
            { name: 'matcapBeige', source: matcapBeigeSource, type: 'texture' },
            { name: 'matcapBlack', source: matcapBlackSource, type: 'texture' },
            { name: 'matcapOrange', source: matcapOrangeSource, type: 'texture' },
            { name: 'matcapRed', source: matcapRedSource, type: 'texture' },
            { name: 'matcapWhite', source: matcapWhiteSource, type: 'texture' },
            { name: 'matcapGreen', source: matcapGreenSource, type: 'texture' },
            { name: 'matcapBrown', source: matcapBrownSource, type: 'texture' },
            { name: 'matcapGray', source: matcapGraySource, type: 'texture' },
            { name: 'matcapEmeraldGreen', source: matcapEmeraldGreenSource, type: 'texture' },
            { name: 'matcapPurple', source: matcapPurpleSource, type: 'texture' },
            { name: 'matcapBlue', source: matcapBlueSource, type: 'texture' },
            { name: 'matcapLightBlue', source: matcapLightBlueSource, type: 'texture' },
            { name: 'matcapYellow', source: matcapYellowSource, type: 'texture' },
            { name: 'matcapMetal', source: matcapMetalSource, type: 'texture' },
            { name: 'matcapGold', source: matcapGoldSource, type: 'texture' },

            { name: 'introStaticBase', source: introStaticBaseSource },
            { name: 'introStaticCollision', source: introStaticCollisionSource },
            { name: 'introStaticFloorShadow', source: introStaticFloorShadowSource, type: 'texture' },

            { name: 'introInstructionsLabels', source: introInstructionsLabelsSource },
            { name: 'introInstructionsArrows', source: introInstructionsArrowsSource, type: 'texture' },
            { name: 'introInstructionsControls', source: introInstructionsControlsSource, type: 'texture' },
            { name: 'introInstructionsOther', source: introInstructionsOtherSource, type: 'texture' },

            { name: 'introArrowKeyBase', source: introArrowKeyBaseSource },
            { name: 'introArrowKeyCollision', source: introArrowKeyCollisionSource },

            { name: 'introZBase', source: introZBaseSource },
            { name: 'introZCollision', source: introZCollisionSource },
            { name: 'introHBase', source: introHBaseSource },
            { name: 'introHCollision', source: introHCollisionSource },
            { name: 'introABase', source: introABaseSource },
            { name: 'introACollision', source: introACollisionSource },
            { name: 'introNBase', source: introNBaseSource },
            { name: 'introNCollision', source: introNCollisionSource },
            { name: 'introGBase', source: introGBaseSource },
            { name: 'introGCollision', source: introGCollisionSource },
            { name: 'introQBase', source: introQBaseSource },
            { name: 'introQCollision', source: introQCollisionSource },
            { name: 'introBBase', source: introBBaseSource },
            { name: 'introBCollision', source: introBCollisionSource },
            { name: 'introRBase', source: introRBaseSource },
            { name: 'introRCollision', source: introRCollisionSource },
            { name: 'introUBase', source: introUBaseSource },
            { name: 'introUCollision', source: introUCollisionSource },
            { name: 'introOBase', source: introOBaseSource },
            { name: 'introOCollision', source: introOCollisionSource },

            { name: 'introSBase', source: introSBaseSource },
            { name: 'introSCollision', source: introSCollisionSource },

            { name: 'introIBase', source: introIBaseSource },
            { name: 'introICollision', source: introICollisionSource },

            { name: 'introMBase', source: introMBaseSource },
            { name: 'introMCollision', source: introMCollisionSource },

            { name: 'introHoppinBase', source: introHoppinBaseSource },
            { name: 'introHoppinCollision', source: introHoppinCollisionSource },

            { name: 'introZqBase', source: introZqBaseSource },
            { name: 'introZqCollision', source: introZqCollisionSource },

            { name: 'crossroadsStaticBase', source: crossroadsStaticBaseSource },
            { name: 'crossroadsStaticCollision', source: crossroadsStaticCollisionSource },
            { name: 'crossroadsStaticFloorShadow', source: crossroadsStaticFloorShadowSource, type: 'texture' },

            { name: 'carDefaultChassis', source: carDefaultChassisSource },
            { name: 'carDefaultWheel', source: carDefaultWheelSource },
            { name: 'carDefaultBackLightsBrake', source: carDefaultBackLightsBrakeSource },
            { name: 'carDefaultBackLightsReverse', source: carDefaultBackLightsReverseSource },
            { name: 'carDefaultAntena', source: carDefaultAntenaSource },
            // { name: 'carDefaultBunnyEarLeft', source: carDefaultBunnyEarLeftSource },
            // { name: 'carDefaultBunnyEarRight', source: carDefaultBunnyEarRightSource },

            { name: 'carCyberTruckChassis', source: carCyberTruckChassisSource },
            { name: 'carCyberTruckWheel', source: carCyberTruckWheelSource },
            { name: 'carCyberTruckBackLightsBrake', source: carCyberTruckBackLightsBrakeSource },
            { name: 'carCyberTruckBackLightsReverse', source: carCyberTruckBackLightsReverseSource },
            { name: 'carCyberTruckAntena', source: carCyberTruckAntenaSource },

            { name: 'projectsBoardStructure', source: projectsBoardStructureSource },
            { name: 'projectsBoardCollision', source: projectsBoardCollisionSource },
            { name: 'projectsBoardStructureFloorShadow', source: projectsBoardStructureFloorShadowSource, type: 'texture' },
            { name: 'projectsBoardPlane', source: projectsBoardPlaneSource },
            { name: 'projectsBoardStructureH', source: projectsBoardStructureHSource },
            { name: 'projectsBoardPlaneH', source: projectsBoardPlaneHSource },

            { name: 'projectsDistinctionsCollisionSBase', source: projectsDistinctionsCollisionSBaseSource },
            { name: 'projectsDistinctionsCollisionLBase', source: projectsDistinctionsCollisionLBaseSource },
            { name: 'projectsDistinctionsActivitiBase', source: projectsDistinctionsActivitiBaseSource },
            { name: 'projectsDistinctionsCBase', source: projectsDistinctionsCBaseSource },
            { name: 'projectsDistinctionsChatGPTBase', source: projectsDistinctionsChatGPTBaseSource },
            { name: 'projectsDistinctionsDockerBase', source: projectsDistinctionsDockerBaseSource },
            { name: 'projectsDistinctionsDubboBase', source: projectsDistinctionsDubboBaseSource },
            { name: 'projectsDistinctionsElasticsearchBase', source: projectsDistinctionsElasticsearchBaseSource },
            { name: 'projectsDistinctionsEurekaBase', source: projectsDistinctionsEurekaBaseSource },
            { name: 'projectsDistinctionsFeignBase', source: projectsDistinctionsFeignBaseSource },
            { name: 'projectsDistinctionsGolangBase', source: projectsDistinctionsGolangBaseSource },
            { name: 'projectsDistinctionsHadoopBase', source: projectsDistinctionsHadoopBaseSource },
            { name: 'projectsDistinctionsHystrixBase', source: projectsDistinctionsHystrixBaseSource },
            { name: 'projectsDistinctionsJavaBase', source: projectsDistinctionsJavaBaseSource },
            { name: 'projectsDistinctionsJMeterBase', source: projectsDistinctionsJMeterBaseSource },
            { name: 'projectsDistinctionsJQueryBase', source: projectsDistinctionsJQueryBaseSource },
            { name: 'projectsDistinctionsKafkaBase', source: projectsDistinctionsKafkaBaseSource },
            { name: 'projectsDistinctionsLuceneBase', source: projectsDistinctionsLuceneBaseSource },
            { name: 'projectsDistinctionsMongoDBBase', source: projectsDistinctionsMongoDBBaseSource },
            { name: 'projectsDistinctionsMybatisBase', source: projectsDistinctionsMybatisBaseSource },
            { name: 'projectsDistinctionsMysqlBase', source: projectsDistinctionsMysqlBaseSource },
            { name: 'projectsDistinctionsNacosBase', source: projectsDistinctionsNacosBaseSource },
            { name: 'projectsDistinctionsNodeBase', source: projectsDistinctionsNodeBaseSource },
            { name: 'projectsDistinctionsOracleBase', source: projectsDistinctionsOracleBaseSource },
            { name: 'projectsDistinctionsPythonBase', source: projectsDistinctionsPythonBaseSource },
            { name: 'projectsDistinctionsQuartzBase', source: projectsDistinctionsQuartzBaseSource },
            { name: 'projectsDistinctionsReactBase', source: projectsDistinctionsReactBaseSource },
            { name: 'projectsDistinctionsRedisBase', source: projectsDistinctionsRedisBaseSource },
            { name: 'projectsDistinctionsRibbonBase', source: projectsDistinctionsRibbonBaseSource },
            { name: 'projectsDistinctionsRocketMQBase', source: projectsDistinctionsRocketMQBaseSource },
            { name: 'projectsDistinctionsSpringBase', source: projectsDistinctionsSpringBaseSource },
            { name: 'projectsDistinctionsThreeBase', source: projectsDistinctionsThreeBaseSource },
            { name: 'projectsDistinctionsVUEBase', source: projectsDistinctionsVUEBaseSource },
            { name: 'projectsDistinctionsZookeeperBase', source: projectsDistinctionsZookeeperBaseSource },

            { name: 'projectsZQProfileFloor', source: projectsZQProfileFloorSource, type: 'texture' },
            { name: 'projectsHoppinBlogFloor', source: projectsHoppinBlogFloorSource, type: 'texture' },
            { name: 'projectsHoppinVideoFloor', source: projectsHoppinVideoFloorSource, type: 'texture' },
            { name: 'projectsHoppinZuiFloor', source: projectsHoppinZuiFloorSource, type: 'texture' },
            { name: 'projectsHoppinChatFloor', source: projectsHoppinChatFloorSource, type: 'texture' },
            { name: 'projectsHoppinManagerFloor', source: projectsHoppinManagerFloorSource, type: 'texture' },
            { name: 'projectsHoppinOtherFloor', source: projectsHoppinOtherFloorSource, type: 'texture' },
            { name: 'projectsValorantFloor', source: projectsValorantFloorSource, type: 'texture' },
            { name: 'projectsYqcrFloor', source: projectsYqcrFloorSource, type: 'texture' },

            { name: 'informationStaticBase', source: informationStaticBaseSource },
            { name: 'informationStaticCollision', source: informationStaticCollisionSource },
            { name: 'informationStaticFloorShadow', source: informationStaticFloorShadowSource, type: 'texture' },

            { name: 'informationBaguetteBase', source: informationBaguetteBaseSource },
            { name: 'informationBaguetteCollision', source: informationBaguetteCollisionSource },

            { name: 'informationContactQQLabel', source: informationContactQQLabelSource, type: 'texture' },
            { name: 'informationContactGithubLabel', source: informationContactGithubLabelSource, type: 'texture' },
            { name: 'informationContactWXLabel', source: informationContactWXLabelSource, type: 'texture' },
            { name: 'informationContactMailLabel', source: informationContactMailLabelSource, type: 'texture' },

            { name: 'informationActivities', source: informationActivitiesSource, type: 'texture' },

            { name: 'playgroundStaticBase', source: playgroundStaticBaseSource },
            { name: 'playgroundStaticCollision', source: playgroundStaticCollisionSource },
            { name: 'playgroundStaticFloorShadow', source: playgroundStaticFloorShadowSource, type: 'texture' },

            { name: 'brickBase', source: brickBaseSource },
            { name: 'brickCollision', source: brickCollisionSource },

            { name: 'hornBase', source: hornBaseSource },
            { name: 'hornCollision', source: hornCollisionSource },

            { name: 'lemonBase', source: lemonBaseSource },
            { name: 'lemonCollision', source: lemonCollisionSource },

            { name: 'bowlingBallBase', source: bowlingBallBaseSource },
            { name: 'bowlingBallCollision', source: bowlingBallCollisionSource },

            { name: 'bowlingPinBase', source: bowlingPinBaseSource },
            { name: 'bowlingPinCollision', source: bowlingPinCollisionSource },

            { name: 'areaKeyEnter', source: areaKeyEnterSource, type: 'texture' },
            { name: 'areaEnter', source: areaEnterSource, type: 'texture' },
            { name: 'areaOpen', source: areaOpenSource, type: 'texture' },
            { name: 'areaReset', source: areaResetSource, type: 'texture' },
            { name: 'areaQuestionMark', source: areaQuestionMarkSource, type: 'texture' },

            { name: 'tilesABase', source: tilesABaseSource },
            { name: 'tilesACollision', source: tilesACollisionSource },

            { name: 'tilesBBase', source: tilesBBaseSource },
            { name: 'tilesBCollision', source: tilesBCollisionSource },

            { name: 'tilesCBase', source: tilesCBaseSource },
            { name: 'tilesCCollision', source: tilesCCollisionSource },

            { name: 'tilesDBase', source: tilesDBaseSource },
            { name: 'tilesDCollision', source: tilesDCollisionSource },

            { name: 'tilesEBase', source: tilesEBaseSource },
            { name: 'tilesECollision', source: tilesECollisionSource },

            { name: 'konamiLabel', source: konamiLabelSource, type: 'texture' },
            { name: 'konamiLabelTouch', source: konamiLabelTouchSource, type: 'texture' },

            { name: 'wig1', source: wig1Source },
            { name: 'wig2', source: wig2Source },
            { name: 'wig3', source: wig3Source },
            { name: 'wig4', source: wig4Source },

            { name: 'eggBase', source: eggBaseSource },
            { name: 'eggCollision', source: eggCollisionSource },
        ])

        this.loader.on('fileEnd', (_resource, _data) =>
        {
            this.items[_resource.name] = _data

            if(_resource.type === 'texture')
            {
                const texture = new THREE.Texture(_data)
                texture.needsUpdate = true

                this.items[`${_resource.name}Texture`] = texture
            }
            this.trigger('progress', [this.loader.loaded / this.loader.toLoad])
        })

        this.loader.on('end', () =>
        {
            this.trigger('ready')
        })
    }
}
